// extracted by mini-css-extract-plugin
export default {"customers":"WR","wrapper":"XR","carousel":"YR","carousel_inner_wrapper":"ZR","top_quote":"aS","bottom_quote":"bS","carousel_wrapper":"cS","feedbacks_wrapper":"eS","arrows":"fS","prev":"gS","img":"hS","review_btn":"iS"};
    if(module.hot) {
      // 1711394579388
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  